import { getArrowHeadGeometry } from '../utils/arrowHead';

const shapesFactory = {
  getPath(x, y) {
    return [
      'path',
      {
        fill: 'none',
        d: `M${x} ${y}`,
        stroke: '#285F3D',
        'stroke-width': 3,
        'stroke-linejoin': 'round',
        'stroke-linecap': 'round',
        'vector-effect': 'non-scaling-stroke',
        class: 'annotation'
      },
    ];
  },
};

const drawRect = {
  getPath(x, y) {
    return [
      'rect',
      {
        x: `${x}`,
        y: `${y}`,
        width: '0',
        height: '0',
        fill: 'none',
        stroke: '#285F3D',
        'stroke-width': 3,
        'stroke-linejoin': 'round',
        'stroke-linecap': 'round',
        'vector-effect': 'non-scaling-stroke',
        originX: `${x}`,
        originY: `${y}`, 
        class: 'annotation'
      }
    ]
  }
};

const drawEllipse = {
  getPath(x, y) {
    return [
      'ellipse',
      {
        cx: `${x}`,
        cy: `${y}`,
        rx: '0',
        ry: '0',
        fill: 'none',
        stroke: '#285F3D',
        'stroke-width': 3,
        'stroke-linejoin': 'round',
        'stroke-linecap': 'round',
        'vector-effect': 'non-scaling-stroke',
        // 회전 상태에서 화면 정렬로 그릴 때 중심 기준점(누름 위치)으로 사용.
        originX: `${x}`,
        originY: `${y}`,
        class: 'annotation'
      }
    ]
  }
};

const ruler = {
  getPath(x, y) {
    return [
      'line',
      {
        x1: `${x}`,
        y1: `${y}`,
        x2: `${x}`,
        y2: `${y}`,
        stroke: '#285F3D',
        'stroke-width': 3,
        'vector-effect': 'non-scaling-stroke',
        length: 0,
        class: 'annotation'
      }
    ]
  }
}

const arrow = {
   getPath(x, y) {
    const arrowHead = getArrowHeadGeometry({
      x1: x,
      y1: y,
      x2: x,
      y2: y,
      zoomLevel: 1,
      aspectRatio: 1,
    });

    return [
      'g',
      {
        class: 'annotation arrow-group',
        // 화살표의 실제 끝점을 저장 (줌 시 재계산용)
        arrowEndX: `${x}`,
        arrowEndY: `${y}`
      },
      [
        'line',
        {
          x1: `${x}`,
          y1: `${y}`,
          x2: `${x}`,
          y2: `${y}`,
          stroke: '#285F3D',
          'stroke-width': 3,
          'vector-effect': 'non-scaling-stroke',
          class: 'arrow-line'
        }
      ],
      [
        'path',
        {
          d: arrowHead.pathD,
          fill: 'none',
          stroke: '#285F3D',
          'stroke-width': 3,
          'stroke-linejoin': 'miter',
          'vector-effect': 'non-scaling-stroke',
          class: 'arrow-head'
        }
      ]
    ];
  }
}

export default function press(x, y, Dispatcher, Store) {
  switch (Store.getMode()) {

    case 'DRAW':
      Dispatcher.dispatch({
        type: 'ACTIVITY_UPDATE',
        inProgress: true,
      });
      Dispatcher.dispatch({
        type: 'ANNOTATIONS_CREATE',
        annotation: shapesFactory.getPath(x, y),
      });
      break;

    case 'DRAWRECT':
      Dispatcher.dispatch({
        type: 'ACTIVITY_UPDATE',
        inProgress: true,
      });
      Dispatcher.dispatch({
        type: 'ANNOTATIONS_CREATE',
        annotation: drawRect.getPath(x, y),
      });
      break;

    case 'DRAWELLIPSE':
      Dispatcher.dispatch({
        type: 'ACTIVITY_UPDATE',
        inProgress: true,
      });
      Dispatcher.dispatch({
        type: 'ANNOTATIONS_CREATE',
        annotation: drawEllipse.getPath(x, y),
      });
      break;

    case 'RULER':
      Dispatcher.dispatch({
        type: 'ACTIVITY_UPDATE',
        inProgress: true,
      });
      Dispatcher.dispatch({
        type: 'ANNOTATIONS_CREATE',
        annotation: ruler.getPath(x, y),
      });
      break;

    case 'DRAWARROW':
      Dispatcher.dispatch({
        type: 'ACTIVITY_UPDATE',
        inProgress: true,
      });
      Dispatcher.dispatch({
        type: 'ANNOTATIONS_CREATE',
        annotation: arrow.getPath(x, y),
      });
      break;

    default:
      break;

  }
}
